/* eslint-disable react-hooks/exhaustive-deps */
import { FC, Fragment, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { ExtraStateContext, siteUrl } from "..";
import { Routes } from "../../../../../../AppRoutes";
import { CreateNotification } from "../../../../../../components/notifier";
import { approverType } from "../../../../../../constants/itCodeRequestConstants";
import { mailRegexs } from "../../../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../../../constants/statusConstants";
import { getDDMMYYYFormat, getHHmmFormat, getUCTDate } from "../../../../../../helper/dateTimeHelper";
import { Button } from "../../../../../../modules/button";
import { SecurityControlCardRequestService } from "../../../../../../services/company-office/SecurityControlCardService";
import { MailService } from "../../../../../../services/mail/mail.service";
import { useSelector } from "../../../../../../store/store";
import ButtonGroup from "../../../../components/ButtonGroup";
import ButtonLayout from "../../../../components/ButtonLayout";
import { useProcess } from "../../../../process-context";
import useApprovalProcess from "../../../securityCardUnits/hooks/use-approval-prcoess";

const FormButton: FC = () => {
  const { Request, approvalStep, approvalType, comment, pickedItHead } = useProcess<ExtraStateContext>();

  const history = useHistory();
  /**
   * Selector
   */
  const employees = useSelector((state: any) => state.employee.employees);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const { currentStep, canApproval, canRecover } = useApprovalProcess({
    data: Request as any,
    steps: [
      {
        approver: 'eApprovedBy',
        status: 'eApprovedStatus'
      },
      {
        approver: 'eApprovedByITLead',
        status: 'eApprovedByITLeadStatus'
      },
      {
        approver: 'eApprovedByITHead',
        status: 'eApprovedByITHeadStatus'
      },
      {
        approver: 'eAssignee',
        status: 'eAssigneeStatus'
      },
    ]
  })

  const checkApproval = () => {
    const { eAssigneeStatus, eApprovedByITLeadStatus, eApprovedByITHeadStatus, eRequestStatus } = Request.fields;
    if (eRequestStatus === requestStatus.rejected || eRequestStatus === requestStatus.completed) {
      return false;
    } else {
      if (approvalStep === approvalType) {
        return true;
      } else {
        if (approvalStep - approvalType === 1) {
          switch (approvalStep) {
            case approverType.itlead:
              return !eApprovedByITLeadStatus;
            case approverType.ithead:
              return !eApprovedByITHeadStatus;
            case approverType.assignee:
              return !eAssigneeStatus;
            default:
              return false;
          }
        }
      }
    }
  };

  const checkEdit = () => {
    // return !Request.fields.eApprovedStatus && !Request.fields.eApprovedByITLeadStatus && !Request.fields.eAssigneeStatus;
    return (
      !Request.fields.eApprovedByITLeadStatus &&
      !Request.fields.eApprovedByITHeadStatus &&
      !Request.fields.eAssigneeStatus
    );
  };

  const checkCurrentUser = () => {
    return currentUserName.toLowerCase() === Request.createdBy.user.email.toLowerCase();
  };

  const getButtonText = () => {
    if (approvalStep === approvalType && approvalStep === approverType.assignee) {
      return "Hoàn thành";
    } else {
      return "Đồng ý";
    }
  };

  /** Mail */

  const sendMail = async (status: string, rejectComment?: any) => {
    const { fields } = Request;
    const url = siteUrl + "/details/" + Request.id;
    let template = mailtemplates.find((m: any) => m.eMailType === "SCTRA");
    let content = template.eContent;
    let subject = template.eSubject;
    let arrApprover = fields.eAssignee.split("|");
    let name = Request.createdBy.user.displayName;
    let tomail = Request.createdBy.user.email;
    let doing = "duyệt";
    if (status === requestStatus.rejected) {
      template = mailtemplates.find((m: any) => m.eMailType === "SCTRR");
      content = template.eContent
        .replace(mailRegexs.zero + ";", name)
        .replace(mailRegexs.one + ";", `${rejectComment?.value} (${rejectComment?.date})`)
        .replace(mailRegexs.siteUrl, url);
      subject = template.eSubject;

      tomail = arrApprover.length > 0 ? arrApprover[0] : "";
      if (approvalStep === approverType.assignee) {
        tomail = Request.createdBy.user.email;
      }
      if (approvalStep === approverType.approver) {
        tomail = Request.createdBy.user.email;
      }
      if (approvalStep === approverType.itlead) {
        tomail = Request.createdBy.user.email;
      }
      if (approvalStep === approverType.ithead) {
        tomail = Request.createdBy.user.email;
      }
    } else if (approvalStep === approverType.assignee) {
      template = mailtemplates.find((m: any) => m.eMailType === "SCTRF");
      tomail = Request.createdBy.user.email;
      name = Request.createdBy.user.displayName;
      content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.one, comment || "");
      subject = template.eSubject;
    } else {
      if (approvalType === approverType.approver) {
        arrApprover = fields.eApprovedByITLead.split("|");
      }
      if (approvalType === approverType.itlead) {
        arrApprover = fields.eApprovedByITHead.split("|");
      }
      if (approvalType === approverType.ithead) {
        arrApprover = fields.eAssignee.split("|");
      }
      tomail = arrApprover.length > 0 ? arrApprover[0] : "";
      name = arrApprover.length > 1 ? arrApprover[1] : "";
      content = template.eContent
        .replace(mailRegexs.zero + ";", name)
        .replace(mailRegexs.one + ";", doing)
        .replace(mailRegexs.two + ";", Request.createdBy.user.displayName)
        .replace(
          mailRegexs.three + ";",
          `${getDDMMYYYFormat(Request.createdDateTime)} - ${getHHmmFormat(Request.createdDateTime)}`,
        )
        .replace(mailRegexs.siteUrl, url);
    }

    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const approveRequest = () => {
    const { fields } = Request;
    const dateApprove = getUCTDate();
    const approveComment = {
      type: "approve",
      value: comment,
      date: `${getDDMMYYYFormat(dateApprove)} ${getHHmmFormat(dateApprove)}`,
    };
    switch (currentStep) {
      case 0:
        const arrComment = fields.eDeptHeadComment ? JSON.parse(fields.eDeptHeadComment) : [];
        const approverComment = [...arrComment];
        approverComment.push(approveComment);
        fields.eDeptHeadComment = JSON.stringify(approverComment);
        fields.eApprovedStatus = requestStatus.approved;
        fields.eApprovedDate = dateApprove;
        break;
      case 1:
        const arrITLeadComment = fields.eITLeadComment ? JSON.parse(fields.eITLeadComment) : [];
        const itLeadComment = [...arrITLeadComment];
        itLeadComment.push(approveComment);
        fields.eITLeadComment = JSON.stringify(itLeadComment);
        fields.eApprovedByITLeadStatus = requestStatus.approved;
        fields.eApprovedByITLeadDate = dateApprove;
        if (pickedItHead) {
          const itLeadTmp = employees.find((f: any) => f.eMail === pickedItHead);
          fields.eAssignee = `${itLeadTmp.eMail}|${itLeadTmp.Title}`;
        }
        break;
      case 2:
        const arrITHeadComment = fields.eITHeadComment ? JSON.parse(fields.eITHeadComment) : [];
        const itHeadComment = [...arrITHeadComment];
        itHeadComment.push(approveComment);
        fields.eITHeadComment = JSON.stringify(itHeadComment);
        fields.eApprovedByITHeadStatus = requestStatus.approved;
        fields.eApprovedByITHeadDate = dateApprove;
        break;
      case 3:
        const arrAssignedComment = fields.eAssigneeComment ? JSON.parse(fields.eAssigneeComment) : [];
        const assignedComment = [...arrAssignedComment];
        assignedComment.push(approveComment);
        fields.eAssigneeComment = JSON.stringify(assignedComment);
        fields.eAssigneeStatus = requestStatus.approved;
        fields.eAssigneeStatusDate = dateApprove;
        fields.eRequestStatus = requestStatus.completed;
        break;
      default:
        break;
    }

    SecurityControlCardRequestService.updateSecurityControlCardRequest(Request.id, fields)
      .then((res) => {
        CreateNotification({
          title: "Thành công",
          body: `Đã duyệt thành công.`,
          icon: "/icons/success.png",
        });
        sendMail(requestStatus.approved);
        history.push(Routes.securityControlCardIssuance.path);
      })
      .catch((err) => {
        CreateNotification({
          title: "Thất bại",
          body: `Đã duyệt thất bại.`,
          icon: "/icons/error.png",
        });
      });
  };

  const recoverRequest = () => {
    const { fields } = Request;
    switch (currentStep) {
      case 1:
        fields.eDeptHeadComment = "";
        fields.eApprovedStatus = "";
        fields.eApprovedDate = null;
        break;
      case 2:
        fields.eITLeadComment = "";
        fields.eApprovedByITLeadStatus = "";
        fields.eApprovedByITLeadDate = null;
        break;
      case 3:
        fields.eITHeadComment = "";
        fields.eApprovedByITHeadStatus = "";
        fields.eApprovedByITHeadDate = null;
        break;
      case -1:
        fields.eAssigneeComment = "";
        fields.eAssigneeStatus = "";
        fields.eAssigneeStatusDate = null;
        fields.eRequestStatus = requestStatus.submitted;
        break;
      default:
        break;
    }
    SecurityControlCardRequestService.updateSecurityControlCardRequest(Request.id, fields)
      .then((res) => {
        CreateNotification({
          title: "Thành công",
          body: `Thu hồi thành công.`,
          icon: "/icons/success.png",
        });
        sendMail(requestStatus.approved);
        history.push(Routes.securityControlCardIssuance.path);
      })
      .catch((err) => {
        CreateNotification({
          title: "Thất bại",
          body: `Thu hồi thất bại.`,
          icon: "/icons/error.png",
        });
      });
  };

  const rejectRequest = () => {
    const { fields } = Request;
    if (!comment) {
      CreateNotification({
        title: "Thông báo",
        body: "Anh Chị vui lòng nhập lưu ý khi từ chối phê duyệt vào ô phía trên !",
        icon: "/icons/warning.png",
      });
      return;
    }
    // fields.eRequestStatus = requestStatus.rejected;
    const dateReject = getUCTDate();
    const rejectComment = {
      type: "reject",
      value: comment,
      date: `${getDDMMYYYFormat(dateReject)} ${getHHmmFormat(dateReject)}`,
    };
    switch (currentStep) {
      case 0:
        const arrComment = fields.eDeptHeadComment ? JSON.parse(fields.eDeptHeadComment) : [];
        const approverComment = [...arrComment];
        approverComment.push(rejectComment);
        fields.eDeptHeadComment = JSON.stringify(approverComment);
        fields.eApprovedStatus = requestStatus.rejected;
        fields.eApprovedDate = dateReject;
        break;
      case 1:
        const arrCommentITLead = fields.eITLeadComment ? JSON.parse(fields.eITLeadComment) : [];
        const approverCommentITLead = [...arrCommentITLead];
        approverCommentITLead.push(rejectComment);
        fields.eITLeadComment = JSON.stringify(approverCommentITLead);
        fields.eApprovedByITLeadStatus = requestStatus.rejected;
        fields.eApprovedByITLeadDate = dateReject;
        break;
      case 2:
        const arrCommentIHead = fields.eITHeadComment ? JSON.parse(fields.eITHeadComment) : [];
        const approverCommentITHead = [...arrCommentIHead];
        approverCommentITHead.push(rejectComment);
        fields.eITHeadComment = JSON.stringify(approverCommentITHead);
        fields.eApprovedByITHeadStatus = requestStatus.rejected;
        fields.eApprovedByITHeadDate = dateReject;
        break;
      case 3:
        const arrCommentAssigned = fields.eAssigneeComment ? JSON.parse(fields.eAssigneeComment) : [];
        const approverCommentAssigned = [...arrCommentAssigned];
        approverCommentAssigned.push(rejectComment);
        fields.eAssigneeComment = JSON.stringify(approverCommentAssigned);
        fields.eAssigneeStatus = requestStatus.rejected;
        fields.eAssigneeStatusDate = dateReject;
        fields.eRequestStatus = requestStatus.rejected;
        break;
      default:
        break;
    }

    SecurityControlCardRequestService.updateSecurityControlCardRequest(Request.id, fields)
      .then((res) => {
        CreateNotification({
          title: "Thành công",
          body: `Từ chối thành công.`,
          icon: "/icons/success.png",
        });
        sendMail(requestStatus.rejected, rejectComment);
        history.push(Routes.securityControlCardIssuance.path);
      })
      .catch((err) => {
        CreateNotification({
          title: "Thất bại",
          body: `Từ chối thất bại.`,
          icon: "/icons/error.png",
        });
      });
  };

  const isApproved = checkApproval();
  const isEdit = checkEdit();
  const isCurrentUser = checkCurrentUser();

  const btnGroups = useMemo(() => {
    return [
      {
        hidden: !isCurrentUser || approvalStep !== 1 || !isEdit,
        content: (
          <Fragment>
            <Button
              className="mr5"
              buttonType="success"
              label="Chỉnh sửa"
              onClick={() =>
                history.push(Routes.createProcedureSecurityControlCardPage.path.replace(":id", Request.id))
              }
            />
          </Fragment>
        ),
      },
      {
        hidden: !canApproval,
        content: [
          {
            hidden: false,
            content: (
              <Fragment>
                <Button className="mr10" buttonType="success" label={getButtonText()} onClick={approveRequest} />
                <Button buttonType="grey" label="Không đồng ý" onClick={rejectRequest} className="mr10" />
              </Fragment>
            ),
          },
          {
            hidden: !isCurrentUser || !isEdit || !canApproval,
            content: (
              <Button
                className="mr5"
                buttonType="warning"
                label="Chỉnh sửa"
                onClick={() =>
                  history.push(Routes.createProcedureSecurityControlCardPage.path.replace(":id", Request.id))
                }
              />
            ),
          },
        ],
      },
      {
        hidden: !canRecover,
        content: <Button buttonType="grey" label="Thu hồi" onClick={recoverRequest} />,
      }
    ];
  }, [
    canRecover,
    canApproval,
    approvalStep,
    approvalType,
    approveRequest,
    isApproved,
    isEdit,
    isCurrentUser,
    Request.id,
    getButtonText,
    history,
    recoverRequest,
    rejectRequest,
  ]);

  if (!btnGroups.some((item) => !item.hidden)) {
    return null;
  }

  return (
    <ButtonLayout smFixed>
      <ButtonGroup data={btnGroups} getItemHidden={(item) => item.hidden} renderContent={(item) => item.content} />
    </ButtonLayout>
  );
};

export default FormButton;
